(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pause-24/assets/javascripts/pause-24.js') >= 0) return;  svs.modules.push('/components/tur/pause-24/assets/javascripts/pause-24.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.Pause24 = class Pause24 {
  constructor() {
    let gameType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'quickGames';
    this.gameType = gameType;
    document.addEventListener('click', e => {
      if (e.target && e.target.classList.contains('js-pause24-trigger')) {
        e.preventDefault();
        this.checkLoggedIn();
      }
    });
  }


  checkLoggedIn() {
    if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      this.confirmPause24();
    } else {
      svs.components.customer_login.login();
    }
  }

  confirmPause24() {
    const pause24view = this;
    const msgBoxOpt = {
      title: 'Spelpaus24',
      message: svs.tur.pause_24.templates.pause_24_confirm_msg({
        nextDay: dateFns.addDays(new Date(), 1)
      }),
      buttons: [{
        text: 'Avbryt',
        callback() {
          const evt = {
            category: 'Spelpaus',
            action: 'Cancel',
            opt_label: 'Pause24'
          };
          svs.components.analytics.trackEvent(evt);
        }
      }, {
        text: 'Aktivera Spelpaus24',
        callback() {
          const evt = {
            category: 'Spelpaus',
            action: 'Activate',
            opt_label: 'Pause24'
          };
          svs.components.analytics.trackEvent(evt);
          pause24view.activatePause24();
        }
      }]
    };
    this.showDialog(msgBoxOpt);
  }

  activatePause24() {
    const self = this;
    const options = {
      path: '/player/1/acutesuspension',
      method: 'post',
      data: {
        product: this.gameType
      }
    };
    const errorFn = function (xhr) {
      let messageBoxOptions = {
        title: 'Tekniskt fel',
        message: 'Kontakta kundservice: 0770 - 11 11 11',
        type: svs.components.MessageBox.Type.ERROR,
        buttons: [{
          text: 'Stäng'
        }]
      };
      switch (xhr.status) {
        case 400:
          if (xhr.responseJSON && xhr.responseJSON.error) {
            const errCodeStr = String(xhr.responseJSON.error.code);
            const errCode = parseInt(errCodeStr.replace(/\s/g, ''), 10);
            switch (errCode) {
              case 225:
                messageBoxOptions = {
                  title: 'Spelpaus aktiverad!',
                  message: "Du har redan en spelpaus.<br>L\xE4s mer <a class=\"suspension-link\" href=\"".concat(svs.core.urlMapping.get('gamingResponsibilityPause'), "\">h\xE4r</a>"),
                  type: svs.components.MessageBox.Type.INFO,
                  buttons: [{
                    text: 'Stäng'
                  }, {
                    text: 'Till spelpaus',
                    callback() {
                      location.href = svs.core.urlMapping.get('gamingResponsibilityPause');
                    }
                  }]
                };
                break;
              case 210: 
              case 255: 
              case 156:
                svs.tur.pause_24.logger.warn("Error posting suspension: ".concat(xhr.responseJSON.error.message));
                break;
              default:
                svs.tur.pause_24.logger.warn("Error posting suspension, unknown error code: ".concat(errCode, ", message: ").concat(xhr.responseJSON.error.message));
            }
          } else {
            svs.tur.pause_24.logger.warn('Error posting suspension, no error object in response');
          }
          break;
        default:
          svs.gaming_responsibility.logger.warn("Error posting suspension, unhandled http status error code: ".concat(xhr.status));
      }
      self.showDialog(messageBoxOptions);
    };
    const successFn = function (response) {
      const message = svs.accountservices.suspension_message.templates.message({
        suspensions: response.suspensions.filter(susp => susp.product === 'quickGames')
      });
      self.showDialog({
        title: 'Spelpaus',
        message
      }, true);
    };
    svs.core.jupiter.call(options, successFn, errorFn);
  }
  showDialog(dialogOptions) {
    const dialogType = Boolean(dialogOptions.type) && dialogOptions.type === svs.components.MessageBox.Type.ERROR ? svs.components.dialog.type.ERROR : svs.components.dialog.type.CONFIRM;
    const dialogButtons = dialogOptions.buttons && dialogOptions.buttons.map(button => {
      let cb;
      if (button.callback) {
        cb = () => {
          button.callback.call();
          dialog.close();
        };
      }
      return {
        title: button.text,
        callback: cb
      };
    }) || [{
      title: 'Ok',
      callback: () => {
        dialog.close();
      }
    }];
    const dialog = new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.TUR,
      icon: 'spelpaus',
      type: dialogType,
      allowDimmerClick: false,
      title: dialogOptions.title,
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: dialogOptions.message
      }],
      actions: dialogButtons
    });
    svs.components.dialog.api.add(dialog);
  }
};
svs.tur.pause24 = new svs.tur.Pause24();

 })(window);